<template>
  <div
    id="messageModal"
    class="modal fade mt-0 mt-md-5"
    tabIndex="-1"
    role="dialog"
    aria-hidden="true"
    ref="messageModal">
    <div class="modal-dialog modal-dialog=centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <small class="text-uppercase text-muted">Subject</small>
            <h4 class="modal-title">{{ message.subject }}</h4>
          </div>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
            <span class="sr-only">Close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-8">
              <small class="text-uppercase text-muted">From</small>
              <h4>
                <a href="'mailto:'+message.fromAddress">
                  {{ message.from }}
                </a>
              </h4>
            </div>
            <div class="col-sm-4">
              <small class="text-uppercase text-muted">Sent</small>
              <h6>{{ message.dtSent }}</h6>
            </div>
            <div class="col-sm-12">
              <p v-html="message.body"></p>
            </div>
          </div>
          <p class="my-3" />
          <button
            class="btn btn-primary float-right ml-2"
            data-dismiss="modal"
            aria-hidden="true"
          >
            Close
          </button>
          <button
            class="btn btn-outline-primary float-right"
            @click="doCompose(message)"
          >
            Reply
          </button>
        </div>
      </div>
    </div>
    <ModalCompose ref="modalCompose" :sendTo="message.from" />
  </div>
</template>
<script>
import ModalCompose from "./ModalCompose";
import jquery from "jquery";

export default {
  props: {
    message: {}
  },
  components: {
    ModalCompose
  },
  methods: {
    show() {
      jquery(this.$refs.messageModal).modal("show");
    },
    doCompose(message) {
      this.$refs.modalCompose.show();
    }
  }
}
</script>
